export default "__VITE_ASSET__DLcOq$rv__"